import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Download, Shield, Zap, Clock, CheckCircle } from "lucide-react";

const theme = {
  accent: "#C98225",
  bgFrom: "#07090f",
  bgTo: "#0b0f19",
};

const TELEGRAM_CHAT = "https://t.me/Bytron";
const SITE_URL = "https://bytron-hack.com";

export default function ProductPage() {
  const { productId } = useParams();
  const [product, setProduct] = useState(null);

  const PRODUCTS = {
    "Crash": {
      title: "Crash Predictor",
      image: "/1xbet-crash.png",
      desc: "Download Crash Predictor APK - The best crash game predictor and 1xbet crash hack. Works on Stake, 1win, 1xbet with Best accuracy. Get crash hack signals in real-time.",
      metaDesc: "Download Crash Predictor APK - Best crash game predictor, 1xbet crash hack, stake crash hack. Works on 1win, 1xbet, Stake. Best accuracy crash signals.",
      price: 100,
      tutorial: "https://t.me/BYTRON_CHANNEL/795",
      features: ["Crash game predictor with Best accuracy", "Works as 1xbet crash hack & stake crash hack", "Real-time crash signals for all platforms"],
    },
    "Aviator Spribe": {
      title: "Aviator Spribe Stake & 1win",
      image: "/1win-aviator.png",
      desc: "Download Aviator Predictor APK - Advanced aviator hack with real-time aviator signals. Works as 1win aviator hack, stake aviator hack, 1xbet aviator hack. Best aviator signal app.",
      metaDesc: "Download Aviator Predictor APK - Best aviator hack, aviator signal app. Works on 1win, 1xbet, Stake. Aviator hack APK with Best accuracy.",
      price: 100,
      tutorial: "https://t.me/BYTRON_CHANNEL/795",
      features: ["Aviator hack APK with instant signals", "Works as stake aviator hack & 1win hack", "Aviator signal app for all casinos"],
    },
    "LuckyJet": {
      title: "LuckyJet Predictor",
      image: "/1win-luckyjet.png",
      desc: "Download LuckyJet Predictor - Accurate LuckyJet hack with real-time signals. Works on 1win LuckyJet. Similar to aviator predictor APK with crash game predictor technology.",
      metaDesc: "Download LuckyJet Predictor APK - LuckyJet hack for 1win. Real-time signals, Best accuracy. Works like aviator predictor and crash predictor.",
      price: 100,
      tutorial: "https://t.me/BYTRON_CHANNEL/795",
      features: ["LuckyJet hack with pattern recognition", "Real-time LuckyJet predictions", "Works on 1win and other platforms"],
    },
    "Mines": {
      title: "Mines Predictor",
      image: "/mines.png",
      desc: "Download Mines Predictor APK - Know exactly where mines are hidden. Works as stake mines hack, 1xbet mines hack. Best mines predictor for all casino platforms.",
      metaDesc: "Download Mines Predictor APK - Stake mines hack, 1xbet mines hack. Know safe spots instantly. Works on Stake, 1win, 1xbet. Best accuracy.",
      price: 100,
      tutorial: "https://t.me/BYTRON_CHANNEL/795",
      features: ["Mines hack with grid analysis", "Stake mines hack & 1xbet mines hack", "Safe spot detection for all platforms"],
    },
    "Mostbet Aviator Spribe": {
      title: "Mostbet Aviator Predictor",
      image: "/mostbet-aviator.png",
      desc: "Download Mostbet Aviator Predictor - Aviator hack optimized for Mostbet. Real-time aviator signals and crash predictions. Works like stake aviator predictor.",
      metaDesc: "Download Mostbet Aviator Predictor APK - Aviator hack for Mostbet. Real-time signals, Best accuracy. Best Mostbet aviator signal app.",
      price: 100,
      tutorial: "https://t.me/BYTRON_CHANNEL/795",
      features: ["Mostbet aviator hack optimized", "Real-time aviator signal sync", "High accuracy aviator predictor"],
    },
    "Apple of Fortune": {
      title: "Apple of Fortune Predictor",
      image: "/apple-of-fortune.png",
      desc: "Download Apple of Fortune Predictor - Know apple position every time. Works on 1xbet, Stake, 1win. Best Apple of Fortune hack with instant predictions.",
      metaDesc: "Download Apple of Fortune Predictor APK - Apple of Fortune hack for 1xbet, Stake, 1win. Know winning position instantly. Best accuracy.",
      price: 100,
      tutorial: "https://t.me/BYTRON_CHANNEL/797",
      features: ["Apple position prediction", "Works on 1xbet, Stake, 1win", "Instant Apple of Fortune signals"],
    },
    "Thimbles": {
      title: "Thimbles Predictor",
      image: "/thimbles.png",
      desc: "Download Thimbles Predictor - Know ball position every time. Thimbles hack for 1xbet, Stake. Advanced tracking algorithm like crash game predictor.",
      metaDesc: "Download Thimbles Predictor APK - Thimbles hack for 1xbet, Stake. Ball tracking with Best accuracy. Never lose at Thimbles again.",
      price: 100,
      tutorial: "https://t.me/BYTRON_CHANNEL/797",
      features: ["Ball tracking technology", "Thimbles hack for all platforms", "100% position detection"],
    },
    "Wild West Gold": {
      title: "Wild West Gold Predictor",
      image: "/wild-west-gold.png",
      desc: "Download Wild West Gold Predictor - Slot predictor and bonus detection. Know winning spins in advance. Works on 1xbet, Stake casino.",
      metaDesc: "Download Wild West Gold Predictor APK - Slot hack and predictor. Bonus detection, win prediction. Works on 1xbet, Stake.",
      price: 100,
      tutorial: "https://t.me/BYTRON_CHANNEL/797",
      features: ["Slot analysis and prediction", "Bonus round detection", "Works on major casinos"],
    },
    "Higher vs Lower": {
      title: "Higher vs Lower Predictor",
      image: "/higher-vs-lower.png",
      desc: "Download Higher vs Lower Predictor - Know the number before choosing. Higher Lower hack for 1xbet, Stake. Win every round with predictions.",
      metaDesc: "Download Higher vs Lower Predictor APK - Higher Lower hack for 1xbet, Stake. Know hidden numbers instantly. Best accuracy.",
      price: 100,
      tutorial: "https://t.me/BYTRON_CHANNEL/797",
      features: ["Number prediction technology", "Higher Lower hack", "Works on 1xbet and Stake"],
    },
    "Dragons Gold": {
      title: "Dragons Gold Predictor",
      image: "/dragons-gold.png",
      desc: "Download Dragons Gold Predictor - Know gold position and win easily. Dragons Gold hack for casino slots. Pattern analysis like crash predictor.",
      metaDesc: "Download Dragons Gold Predictor APK - Dragons Gold slot hack. Gold detection, pattern analysis. Works on major casinos.",
      price: 100,
      tutorial: "https://t.me/BYTRON_CHANNEL/797",
      features: ["Gold position detection", "Pattern analysis technology", "High win rate predictions"],
    },
  };

  useEffect(() => {
    const prod = PRODUCTS[productId];
    setProduct(prod);
    window.scrollTo(0, 0);

    // Dynamically update meta tags for SEO
    if (prod) {
      // Update title
      document.title = `${prod.title} Download | Aviator Hack, Crash Predictor | BYTRON`;
      
      // Update or create canonical link
      let canonical = document.querySelector('link[rel="canonical"]');
      if (canonical) {
        canonical.href = `${SITE_URL}/product/${encodeURIComponent(productId)}`;
      } else {
        canonical = document.createElement('link');
        canonical.rel = 'canonical';
        canonical.href = `${SITE_URL}/product/${encodeURIComponent(productId)}`;
        document.head.appendChild(canonical);
      }
      
      // Update meta description
      let metaDesc = document.querySelector('meta[name="description"]');
      if (metaDesc) {
        metaDesc.content = prod.metaDesc || prod.desc;
      }

      // Update OG tags
      let ogTitle = document.querySelector('meta[property="og:title"]');
      if (ogTitle) ogTitle.content = `${prod.title} Download | BYTRON`;
      
      let ogDesc = document.querySelector('meta[property="og:description"]');
      if (ogDesc) ogDesc.content = prod.metaDesc || prod.desc;
      
      let ogUrl = document.querySelector('meta[property="og:url"]');
      if (ogUrl) ogUrl.content = `${SITE_URL}/product/${encodeURIComponent(productId)}`;
    }

    // Cleanup - restore original meta when leaving
    return () => {
      document.title = "Aviator Predictor APK Download | Aviator Hack, Crash Predictor, 1win & Stake Hack";
      let canonical = document.querySelector('link[rel="canonical"]');
      if (canonical) canonical.href = `${SITE_URL}/`;
    };
  }, [productId]);

  if (!product) {
    return (
      <div
        className="min-h-screen flex items-center justify-center text-white px-4"
        style={{ background: `linear-gradient(180deg, ${theme.bgFrom}, ${theme.bgTo})` }}
      >
        <div className="text-center">
          <p className="text-lg sm:text-xl mb-4">Product not found</p>
          <Link to="/" className="text-amber-400 hover:text-amber-300 active:text-amber-200">
            ← Back to Home
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div
      className="min-h-screen text-white"
      style={{ background: `linear-gradient(180deg, ${theme.bgFrom}, ${theme.bgTo})` }}
    >
      <div className="max-w-4xl mx-auto p-4 sm:p-6 pt-4 sm:pt-8 pb-8">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-white/70 hover:text-white active:text-white/80 mb-4 sm:mb-6 transition py-2"
        >
          <ArrowLeft className="h-4 w-4" />
          <span className="text-sm sm:text-base">Back to Catalog</span>
        </Link>

        <div className="grid md:grid-cols-2 gap-6 sm:gap-8">
          <div>
            <div
              className="rounded-xl sm:rounded-2xl border-2 sm:border-4 overflow-hidden"
              style={{ borderColor: theme.accent }}
            >
              <img src={product.image} className="w-full aspect-video object-cover" alt={product.title} />
            </div>
            
            <div className="mt-4 grid grid-cols-3 gap-2">
              <div className="flex flex-col items-center p-3 rounded-lg bg-white/5 border border-white/10">
                <Shield className="h-5 w-5 text-green-400 mb-1" />
                <span className="text-xs text-white/60">Undetectable</span>
              </div>
              <div className="flex flex-col items-center p-3 rounded-lg bg-white/5 border border-white/10">
                <Zap className="h-5 w-5 text-amber-400 mb-1" />
                <span className="text-xs text-white/60">Best Accurate</span>
              </div>
              <div className="flex flex-col items-center p-3 rounded-lg bg-white/5 border border-white/10">
                <Clock className="h-5 w-5 text-blue-400 mb-1" />
                <span className="text-xs text-white/60">24/7 Support</span>
              </div>
            </div>
          </div>

          <div>
            <h1 className="text-2xl sm:text-3xl font-bold mb-2">{product.title}</h1>
            
            <div className="flex items-center gap-2 mb-4">
              <div className="flex">
                {[1,2,3,4,5].map(i => (
                  <span key={i} className="text-amber-400">★</span>
                ))}
              </div>
              <span className="text-sm text-white/60">(1,247 reviews)</span>
            </div>

            <div className="mb-4">
              <span className="text-3xl font-bold text-amber-400">${product.price}</span>
              <span className="text-white/60 ml-2 line-through">$199</span>
              <span className="ml-2 px-2 py-1 bg-green-500/20 text-green-400 text-xs rounded-full">50% OFF</span>
            </div>

            <p className="text-white/70 mb-6 leading-relaxed text-sm sm:text-base">{product.desc}</p>

            <div className="mb-6">
              <h3 className="font-semibold mb-3">Features:</h3>
              <ul className="space-y-2">
                {product.features?.map((feature, i) => (
                  <li key={i} className="flex items-center gap-2 text-sm text-white/70">
                    <CheckCircle className="h-4 w-4 text-green-400 flex-shrink-0" />
                    {feature}
                  </li>
                ))}
              </ul>
            </div>

            <div className="mb-6 p-4 rounded-xl bg-white/5 border border-white/10">
              <h3 className="font-semibold mb-3">How to Download:</h3>
              <ol className="list-decimal pl-5 space-y-1 text-white/60 text-sm">
                <li>Contact us on Telegram @Bytron</li>
                <li>Receive APK download link instantly</li>
                <li>Install predictor on Android 7+</li>
                <li>Open game and start winning</li>
              </ol>

              {product.tutorial && (
                <a
                  href={product.tutorial}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-4 inline-flex items-center gap-2 text-amber-400 hover:text-amber-300 active:text-amber-200 text-sm"
                >
                  ▶ Watch Video Tutorial
                </a>
              )}
            </div>

            <button
              onClick={() => window.open(TELEGRAM_CHAT, "_blank")}
              className="w-full py-4 rounded-xl font-semibold text-lg flex items-center justify-center gap-2
                bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 text-black transition-all"
            >
              <Download className="h-5 w-5" />
              Download {product.title} APK
            </button>

            <p className="text-center text-white/50 text-xs sm:text-sm mt-3">
              Instant APK delivery • Lifetime access • Free updates
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
